import React from "react";
import {connect} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ErrorMessage, LoadingBoton, TIPO_CONVERSACION} from "../../../_helpers";
import {Field, Form, Formik} from "formik";
import * as Yup from 'yup';
import alertService from "../../../_services/cart/alert.service";
import http from "../../../_services/cart/http.service";
import authService from "../../../_services/cart/authService";

const MAX_CONSULTA = 300;

/**
 * Lo que cambia segun desde donde se abre el formulario.
 *
 * <p>`sugerencias` son frases para arrancar el mensaje: quien quiere vender casi siempre pregunta
 * lo mismo, y un toque le ahorra escribirlo en el telefono. Tocar una la agrega al texto, no lo
 * pisa.
 */
const TEXTOS = {
    [TIPO_CONVERSACION.NUEVO_VENDEDOR]: {
        icono: "fa-solid fa-store",
        titulo: "Vendé tus autopartes con nosotros",
        bajada: "Contanos de tu negocio y te ayudamos a registrarte y publicar.",
        sugerencias: [
            "Quiero registrarme como vendedor.",
            "¿Cuánto cuesta publicar?",
            "Tengo muchas piezas para cargar.",
        ],
        exito: "Gracias por tu consulta. Te contestaremos a la brevedad al medio de contacto que hayas ingresado",
    },
    [TIPO_CONVERSACION.NUEVA_MARCA]: {
        icono: "fa-solid fa-car",
        titulo: "¿Falta un modelo?",
        bajada: "Decinos cuál y lo cargamos.",
        exito: "Gracias. Cargaremos en las proximas horas el modelo faltante.",
    },
    [TIPO_CONVERSACION.GENERAL]: {
        icono: "fa-solid fa-comments",
        titulo: "Escribinos",
        bajada: "Tu consulta, duda o sugerencia. Te respondemos a la brevedad.",
    },
};

const TEXTO_DEFAULT = {
    icono: "fa-solid fa-comments",
    titulo: "Escribinos",
    bajada: "Te respondemos a la brevedad.",
};

class ConsultaModal extends React.Component {

    state = {
        grabando: false
    }

    enviar = (values) => {
        const textos = TEXTOS[values.type] || TEXTO_DEFAULT;

        // Antes el campo no existia en los valores iniciales si no se tocaba: se sigue sin mandar
        // vacio, para que el backend no reciba un contacto "" de alguien logueado.
        const payload = {...values};
        if (!payload.contacto) delete payload.contacto;

        this.setState({grabando: true});

        http.post('/public/chat/nuevo', payload).then(
            () => {
                alertService.msg(textos.exito || 'Consulta enviada exitosamente!');
                this.setState({grabando: false});
                this.props.handleClose();
            },
            error => {
                alertService.error(error)
                this.setState({grabando: false});
            }
        );
    };

    render() {
        const {type} = this.props;
        const logueado = authService.isAuthenticated();
        const textos = TEXTOS[type] || TEXTO_DEFAULT;

        const validateObject = {
            body: Yup.string()
                .min(8, 'La consulta debe tener al menos 8 caracteres')
                .max(MAX_CONSULTA, 'Demasiado largo')
                .required('Escribí tu consulta'),
        };

        // Logueado no hace falta: el backend ya sabe como contestarle.
        if (!logueado) {
            validateObject.contacto = Yup.string()
                .min(8, 'El contacto debe tener al menos 8 caracteres')
                .max(300, 'Demasiado largo')
                .required('Necesitamos un teléfono o email para responderte');
        }

        return (
            <Formik
                enableReinitialize={true}
                initialValues={{type: type, body: "", contacto: ""}}
                validationSchema={Yup.object().shape(validateObject)}
                onSubmit={this.enviar}>
                {({values, setFieldValue}) => (
                    <Form className="consulta">
                        <div className="consulta__intro">
                            <span className="consulta__icono" aria-hidden="true">
                                <FontAwesomeIcon icon={textos.icono}/>
                            </span>
                            <div>
                                <strong>{textos.titulo}</strong>
                                <p>{textos.bajada}</p>
                            </div>
                        </div>

                        {!logueado && (
                            <div className="consulta__campo">
                                <label htmlFor="consulta-contacto">¿Cómo te contactamos?</label>
                                <div className="consulta__input">
                                    <FontAwesomeIcon icon="fa-solid fa-at" aria-hidden="true"/>
                                    <Field
                                        id="consulta-contacto"
                                        type="text"
                                        name="contacto"
                                        placeholder="Teléfono o email"
                                        autoComplete="email"
                                    />
                                </div>
                                <ErrorMessage name="contacto"/>
                            </div>
                        )}

                        <div className="consulta__campo">
                            <label htmlFor="consulta-body">Tu mensaje</label>

                            {!!textos.sugerencias && (
                                <div className="consulta__sugerencias">
                                    {textos.sugerencias.map((s) => (
                                        <button
                                            key={s}
                                            type="button"
                                            className="consulta__chip"
                                            onClick={() =>
                                                setFieldValue(
                                                    "body",
                                                    (values.body ? values.body.trimEnd() + " " : "") + s
                                                )
                                            }
                                        >
                                            {s}
                                        </button>
                                    ))}
                                </div>
                            )}

                            <Field
                                id="consulta-body"
                                as="textarea"
                                name="body"
                                rows="4"
                                maxLength={MAX_CONSULTA}
                                placeholder="Escribí acá tu consulta…"
                            />
                            <div className="consulta__pie-campo">
                                <ErrorMessage name="body"/>
                                <span className="consulta__contador">
                                    {(values.body || "").length}/{MAX_CONSULTA}
                                </span>
                            </div>
                        </div>

                        <button
                            className="button consulta__enviar"
                            data-type="accent"
                            type="submit"
                            disabled={this.state.grabando}
                        >
                            {this.state.grabando
                                ? <LoadingBoton grabando={true}/>
                                : <>
                                    <FontAwesomeIcon icon="fa-solid fa-paper-plane"/>
                                    <span>Enviar mensaje</span>
                                </>}
                        </button>
                    </Form>
                )}
            </Formik>
        );
    }
}

function mapState(state) {
    return {};
}

const actionCreators = {};

const connectedConsultaModal = connect(mapState, actionCreators)(ConsultaModal);
export {connectedConsultaModal as ConsultaModal};
